import { render, staticRenderFns } from "./RespetarReglas.vue?vue&type=template&id=7f74fd00&scoped=true&"
import script from "./RespetarReglas.vue?vue&type=script&lang=js&"
export * from "./RespetarReglas.vue?vue&type=script&lang=js&"
import style0 from "./RespetarReglas.vue?vue&type=style&index=0&id=7f74fd00&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f74fd00",
  null
  
)

export default component.exports